module.exports = __webpack_public_path__ + "img/zphd_icon_gold.505b3221.png";